import NewSubscribe from '@/app/(events)/events/new-subscribe/index/page';
import AutopayBenefit from '@/app/(events)/events/autopay-benefit/index/page';
import SoopiDailyMission from '@/app/(events)/events/soopi/daily-mission/index/page';
import SoopiConversation from '@/app/(events)/events/soopi/conversation/index/page';
import SubscribePlus from '@/app/(events)/events/subs_plus/index/page';
import MarketingConsent from '@/app/(events)/events/marketing-consent/index/page';
import FreecshotPlus from '@/app/(events)/events/freecshot-plus/index/page';
import SubscribeDirectChange from '@/app/(events)/events/subs-direct-change/index/page';
import SavygEventApply from '@/app/(events)/events/savyg-event/apply/index/page';
import SavygEventAward from './savyg-event/award/index/page';

export {
  NewSubscribe,
  AutopayBenefit,
  SoopiDailyMission,
  SoopiConversation,
  SubscribePlus,
  MarketingConsent,
  FreecshotPlus,
  SubscribeDirectChange,
  SavygEventApply,
  SavygEventAward,
};
